$( document ).ready(function() {

   $('.assoonlogoslider').slick({
   slidesToShow: 7,
  slidesToScroll: 7,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true
      }
    }
  ]
});

$('.tab-link').click( function() {
	
	var tabID = $(this).attr('data-tab');
	
	$(this).addClass('active').siblings().removeClass('active');
	
	$('#tab-'+tabID).addClass('active').siblings().removeClass('active');
});
$(".cstm-accordion-faq > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".cstm-accordion-faq-para")
        .slideUp(200);
      $(".cstm-accordion-faq > a i")
        .removeClass("fa-minus-circle")
        .addClass("fa-plus-circle");
    } else {
      $(".cstm-accordion-faq > a i")
        .removeClass("fa-minus-circle")
        .addClass("fa-plus-circle");
      $(this)
        .find("i")
        .removeClass("fa-plus-circle")
        .addClass("fa-minus-circle");
      $(".cstm-accordion-faq > a").removeClass("active");
      $(this).addClass("active");
      $(".cstm-accordion-faq-para").slideUp(200);
      $(this)
        .siblings(".cstm-accordion-faq-para")
        .slideDown(200);
    }
  });
 
 $('.product-slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  asNavFor: '.product-slider-nav'
});
$('.product-slider-nav').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  asNavFor: '.product-slider-for',
  focusOnSelect: true
});
  
  // recommendation section show hide
//  var $this=jQuery(".product__title h1").text();
// $(".cstm-recommendations-product .container .recommendation-slider div").each(function(){
// var custom_rec=$(this).find(".custom-product-recommendation-title").text();

// if($this==jQuery(this).find(".custom-product-recommendation-title").text()
// ){
// console.log($this);
// $(this).css("display","none");

// }
// // else{
// //     $(this).css("display","block");
// // }
// });
  
  
  $('.recommendation-slider').slick({
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots:true,
    responsive: [ {
      breakpoint: 770,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
      }
    }]
  });
  
});
